import { useFormContext } from 'react-hook-form';

import { PaymentProvider } from '@/types/tickets';

interface props {
    name: string;
    provider: PaymentProvider;
}

export default function PaymentOption({ provider, ...props }: props) {
    const { register, setValue } = useFormContext();

    return (
        <div
            className="flex max-h-20 w-full cursor-pointer gap-2 border border-gray-200 bg-white p-2 pl-3"
            onClick={() => setValue(props.name, provider.id)}
        >
            <div className="flex w-[3.375rem] items-center p-1">
                <div
                    className="h-full max-h-6 w-full bg-contain bg-center bg-no-repeat"
                    style={{ backgroundImage: `url(/assets/icons/payment-cards/${provider.id}.svg)` }}
                ></div>
            </div>
            <div className="flex flex-1 flex-col gap-1">
                <span className="line-clamp-1 text-sm">
                    {provider.name} <span className="font-bold">{provider.currency_code}</span>
                </span>
                <span className="line-clamp-1 text-xs sm:line-clamp-2">{provider.description}</span>
            </div>
            <div className="flex">
                <input {...register(props.name)} type="radio" value={provider.id} id={`${props.name}-${provider.id}`} />
            </div>
        </div>
    );
}
